export default __webpack_public_path__ + "static/media/gallery (17).6855ef23.png";